import React from 'react';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { InsuranceToDelete } from '../../Insurance.meta';
import { useDeleteInsuranceMutation } from '../../api/useDeleteInsuranceMutation';

interface Props {
  clientId: string;
  insurance: InsuranceToDelete;
  onClose(): void;
  onDelete(): void;
}

export const DeleteInsuranceModal = ({ clientId, insurance, onClose, onDelete }: Props) => {
  const {
    mutateAsync: deleteInsurance,
    isLoading: isDeletingInsurance,
    error: deleteInsuranceError,
  } = useDeleteInsuranceMutation({ clientId });

  const handleDeleteInsurance = async () => {
    try {
      await deleteInsurance({ clientId, id: insurance.id });

      onDelete();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'insurance--delete--modal-header' }}
    >
      <ModalHeader as="h2" id="insurance--delete--modal-header">
        Are you sure you want to delete this account?
      </ModalHeader>

      {deleteInsuranceError && (
        <Alert message={deleteInsuranceError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="error"
          isLoading={isDeletingInsurance}
          onClick={handleDeleteInsurance}
          ml="8"
        >
          Delete Account
        </Button>
      </ModalFooter>
    </Modal>
  );
};
